import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MenuOptions } from '../../../_models/menu-options';
import { DatasheetMenuOptions } from '../../../_data/datasheet-nav-tabs.data';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-nav-view-datasheet',
  templateUrl: './nav-view-datasheet.component.html',
  styleUrls: ['./nav-view-datasheet.component.css']
})
export class NavViewDatasheetComponent implements OnInit, OnDestroy {
  @Input() activeLink: string;
  @Input() entryDate: string;
  menuOptions: MenuOptions[];

  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(

  ) {

  }

  ngOnInit() {
    this.menuOptions = DatasheetMenuOptions;



  }


  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  
}
